import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { SelectBox, Button, SelectBoxItem, Toast } from "../../../components";
import { Previous } from "../../../components/Icons/Icons";
import useFetchData from "../../../hooks/useFetchData";
import PropTypes from "prop-types";
import styles from "./Filter.module.css";
import axiosClient from "../../../services/axiosClient";
import {
  defaultCompanyFill,
  normalCompanyFill,
} from "../../Administration/Camera/Filter/configFillter";
import { convertStatus } from "../../../utils";
import { useTranslation } from "react-i18next";
const cx = classNames.bind(styles);
const Filter = ({ onFilter, fillOn, isGroup, type, setPlate, plate, setIsVideoAI }) => {
  const { t } = useTranslation()
  const [cam, setCam] = useState({
    code: null,
    name: "",
    type: "group",
  });
  const [provinceCode, setProvinceCode] = useState({
    code: null,
    name: "",
    type: "province",
  });
  const [districtCode, setDistrictCode] = useState({
    code: null,
    name: "",
    type: "district",
  });
  const [communeCode, setCommuneCode] = useState({
    code: null,
    name: "",
    type: "commune",
  });
  const [status, setStatus] = useState({
    name: "",
    code: null,
    type: "status",
  });
  const [record, setRecord] = useState({
    name: t("location.isRecord"),
    code: 1,
    type: "record",
  });
  const [province, setProvince] = useState();
  const [district, setDistrict] = useState();
  const [commune, setCommune] = useState();
  const companyCode = sessionStorage.getItem("company_code");
  const fillOptions =
    companyCode === "DEFAULT" ? defaultCompanyFill : normalCompanyFill;
  // get list item fill
  const groupCam = useFetchData("groupCam/get-list-groupCam/");
  useEffect(() => {
    const getProvince = async () => {
      try {
        const res = await axiosClient.get("province/get-info-province/", {
          nation_code: "VNM",
        });
        if (res) {
          const data = res.sort((a, b) =>
            a.PROVINCE_NAME?.normalize("NFC").localeCompare(
              b.PROVINCE_NAME?.normalize("NFC"),
              "vi",
              { sensitivity: "accent" }
            )
          );
          setProvince(data);
        }
      } catch (error) {
        Toast.open(t("location.getCityError"), "danger");
      }
    };
    getProvince();
  }, []);

  useEffect(() => {
    if (provinceCode.code) {
      const getDistrict = async () => {
        try {
          const res = await axiosClient.get(
            `district/get-list-district/?province_code=${provinceCode.code}`
          );
          if (res) {
            const data = res.sort((a, b) =>
              a.DISTRICT_NAME?.normalize("NFC").localeCompare(
                b.DISTRICT_NAME?.normalize("NFC"),
                "vi",
                { sensitivity: "accent" }
              )
            );
            setDistrict(data);
          }
        } catch (error) {
          Toast.open(t("location.getDistrictError"), "danger");
        }
      };
      getDistrict();
    }
  }, [provinceCode.code]);

  useEffect(() => {
    if (districtCode.code) {
      const getDistrict = async () => {
        try {
          const res = await axiosClient.get(
            `commune/get-list-commune/?district_code=${districtCode.code}`
          );
          if (res) {
            const data = res.sort((a, b) =>
              a.COMMUNE_NAME?.normalize("NFC").localeCompare(
                b.COMMUNE_NAME?.normalize("NFC"),
                "vi",
                { sensitivity: "accent" }
              )
            );
            setCommune(data);
          }
        } catch (error) {
          Toast.open(t("location.getCommuneError"), "danger");
        }
      };
      getDistrict();
    }
  }, [districtCode.code]);
  const handleBack = () => {
    onFilter([]);
  };
  const handleClick = () => {
    if (fillOn === "video") {
      onFilter([cam, provinceCode, districtCode, communeCode, status, record]);
    } else {
      onFilter([cam, provinceCode, districtCode, communeCode, status, {
        name: convertStatus(plate),
        code: plate,
        type: "statusAI",
      }]);
    }
  };
  const handleChangeGroupCam = (data, label) => {
    setCam({
      ...cam,
      name: label,
      code: data,
    });
  };
  const handleChangeProvince = (data, label) => {
    setProvinceCode({
      ...provinceCode,
      name: label,
      code: data,
    });
  };
  const handleChangeDistrict = (data, label) => {
    setDistrictCode({
      ...districtCode,
      name: label,
      code: data,
    });
  };
  const handleChangeCommune = (data, label) => {
    setCommuneCode({
      ...communeCode,
      name: label,
      code: data,
    });
  };
  const handleChangeStatus = (data, label) => {
    if (data === "all") {
      setStatus({
        ...status,
        name: "",
        code: null,
      });
    } else {
      setStatus({
        ...status,
        name: label,
        code: data,
      });
    }
  };
  const handleChangeRecord = (data, label) => {
    if (data === "all") {
      setRecord({
        ...record,
        name: "",
        code: null,
      });
      if (setIsVideoAI) {
        setIsVideoAI(null);
      }
    } else {
      setRecord({
        ...record,
        name: label,
        code: data,
      });
      if (setIsVideoAI) {
        setIsVideoAI(data);
      }
    }
  };
  return (
    <div>
      <div id="__notification"></div>
      <div className={cx("header")}>
        <span style={{ paddingTop: 4 }} onClick={handleBack}>
          <Previous />
        </span>
        <p className={cx("title")}>{t("location.filter")}</p>
      </div>
      <div className={cx("content")}>
        {!isGroup && (
          <>
            <SelectBox
              style={{ paddingBottom: 4, paddingTop: 0 }}
              type="big"
              label={t("location.groupCam")}
              onChange={handleChangeGroupCam}
            >
              {groupCam.data &&
                groupCam?.data?.data?.map((item, index) => (
                  <SelectBoxItem
                    label={item.SUBJECT_NAME}
                    value={item.CODE}
                    key={index}
                  />
                ))}
            </SelectBox>
            <SelectBox
              type="big"
              style={{ paddingBottom: 4, paddingTop: 0 }}
              onChange={handleChangeProvince}
              label={t("location.province")}
            >
              {province &&
                province?.map((item, index) => (
                  <SelectBoxItem
                    label={item.PROVINCE_NAME}
                    value={item.PROVINCE_CODE}
                    key={index}
                  />
                ))}
            </SelectBox>
            <SelectBox
              type="big"
              style={{ paddingBottom: 4, paddingTop: 0 }}
              onChange={handleChangeDistrict}
              label={t("location.district")}
            >
              {district &&
                district?.map((item, index) => (
                  <SelectBoxItem
                    label={item.DISTRICT_NAME}
                    value={item.DISTRICT_CODE}
                    key={index}
                  />
                ))}
            </SelectBox>
            <SelectBox
              type="big"
              style={{ paddingBottom: 4, paddingTop: 0 }}
              onChange={handleChangeCommune}
              label={t("location.commune")}
            >
              {commune &&
                commune?.map((item, index) => (
                  <SelectBoxItem
                    label={item.COMMUNE_NAME}
                    value={item.COMMUNE_CODE}
                    key={index}
                  />
                ))}
            </SelectBox>
          </>
        )}
        <SelectBox
          type="big"
          style={{ paddingBottom: 4, paddingTop: 0 }}
          onChange={handleChangeStatus}
          label={t("location.status")}
        >
          <SelectBoxItem label={t("location.all")} value="all" />
          {fillOptions.map((item) => {
            return (
              <SelectBoxItem
                key={item.value}
                label={item.label}
                value={item.value}
              />
            );
          })}
        </SelectBox>
        {fillOn && fillOn === "video" && (
          <SelectBox
            type="big"
            style={{ paddingBottom: 4, paddingTop: 0 }}
            onChange={handleChangeRecord}
            label={t("location.record")}
            values={record?.name}
          >
            <SelectBoxItem label={t("location.all")} value="all" />
            <SelectBoxItem label={t("location.isRecord")} value={1} />
            <SelectBoxItem label={t("location.noRecord")} value={0} />
          </SelectBox>
        )}
        {type === "plate" && (
          <SelectBox
            type="big"
            style={{ paddingBottom: 4, paddingTop: 0 }}
            onChange={(data) => setPlate(data)}
            label={t("location.statusService")}
            values={convertStatus(plate)}
          >
            <SelectBoxItem label={t("location.all")} value="all" />
            <SelectBoxItem label={t("location.isOn")} value={"On"} />
            <SelectBoxItem label={t("location.isOff")} value={"Off"} />
          </SelectBox>
        )}
        <div style={{ paddingTop: 8 }}>
          <Button title={t("location.accept")} onClick={handleClick} />
        </div>
      </div>
    </div>
  );
};
Filter.propTypes = {
  onFilter: PropTypes.func.isRequired,
};
export default Filter;
